import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PrizesSlice {
  number_of_times: number;
  purchase_point: number;
  total_points_to_exchange: number;
  prizes: any;
  selected_prize: any;
  effect_type: string;
  prize_label: string;
  selectedPrizeId: number[];
}
const initialState: PrizesSlice = {
  number_of_times: 0,
  purchase_point: 0,
  total_points_to_exchange: 0,
  prizes: [],
  selected_prize: {},
  effect_type: "movie",
  prize_label: "",
  selectedPrizeId: [],
};

const prizesSlice = createSlice({
  name: "prizesObject",
  initialState,
  reducers: {
    toggleSelectedPrizeId(state, action: PayloadAction<number>) {
      const selectedIdIndex = state.selectedPrizeId.indexOf(action.payload);
      if (selectedIdIndex === -1) {
        return {
          ...state,
          selectedPrizeId: [...state.selectedPrizeId, action.payload],
        };
      } else {
        return {
          ...state,
          selectedPrizeId: [
            ...state.selectedPrizeId.slice(0, selectedIdIndex),
            ...state.selectedPrizeId.slice(selectedIdIndex + 1),
          ],
        };
      }
    },
    removeSelectedPrizeId(state) {
      return {
        ...state,
        selectedPrizeId: [],
      };
    },
    setSelectedPrizeId(state, action: PayloadAction<number>) {
      // Check if the action.payload (ID) is not already in the array
      if (!state.selectedPrizeId.includes(action.payload)) {
        return {
          ...state,
          selectedPrizeId: [...state.selectedPrizeId, action.payload],
        };
      }
      // If the ID already exists, return the current state without modification
      return state;
    },
    setPrizes(state, action: PayloadAction<any>) {
      return {
        ...state,
        prizes: action.payload,
      };
    },
    removeOneItemPrize(state) {
      return {
        ...state,
        prizes: state.prizes.slice(1, state.prizes.length),
      };
    },
    setSelectedPrizes(state, action: PayloadAction<number>) {
      return {
        ...state,
        selected_prize: action.payload,
      };
    },
    unSelectedPrizes(state) {
      state.selected_prize = {};
    },
    setNumberTimes(state, action: PayloadAction<number>) {
      state.number_of_times = action.payload;
    },
    setPurchasePoint(state, action: PayloadAction<number>) {
      state.purchase_point = action.payload;
    },
    setTotalPointCanExchange(state, action: PayloadAction<number>) {
      state.total_points_to_exchange = action.payload;
    },
    reduceNumberTimes(state) {
      state.number_of_times--;
    },
    unSetPrizes: (state) => {
      state.number_of_times = 0;
      state.prizes = {};
    },
    setEffectType(state, action: PayloadAction<string>) {
      state.effect_type = action.payload;
    },
    setPrizeLabel(state, action: PayloadAction<string>) {
      state.prize_label = action.payload;
    },
  },
});

//Actions
export const prizesActions = prizesSlice.actions;

//Selector
export const selectSelectedPrizeId = (state: {
  prizesObject: { selectedPrizeId: number[] };
}) => state.prizesObject.selectedPrizeId;

export const selectPurchasePoint = (state: {
  prizesObject: { purchase_point: number };
}) => state.prizesObject.purchase_point;

export const selectTotalPointCanExchange = (state: {
  prizesObject: { total_points_to_exchange: number };
}) => state.prizesObject.total_points_to_exchange;

export const selectPrizeTimes = (state: {
  prizesObject: { number_of_times: number };
}) => state.prizesObject.number_of_times;

export const selectPrizeSelected = (state: {
  prizesObject: { selected_prize: any };
}) => state.prizesObject.selected_prize;

export const selectPrizes = (state: { prizesObject: { prizes: any } }) =>
  state.prizesObject.prizes;

export const selectEffectType = (state: {
  prizesObject: { effect_type: string };
}) => state.prizesObject.effect_type;

export const selectPrizeLabel = (state: {
  prizesObject: { prize_label: string };
}) => state.prizesObject.prize_label;

//Reducer
export const prizesReducer = prizesSlice.reducer;
